import { Text } from "@wojo/ui";
import React, { HtmlHTMLAttributes } from "react";
import styles from "./TripBuilderDeparturesStep.module.scss";

export const DepartureListYear: React.FC<
    React.PropsWithChildren<{}> & HtmlHTMLAttributes<HTMLTableRowElement>
> = ({ children, ...props }) => {
    return (
        <tr className={styles["year-heading"]} {...props}>
            <th
                colSpan={3}
                style={{
                    padding: "var(--g-spacing-sm) var(--g-spacing-md)",
                }}
            >
                <Text.Heading order="6" tag="span">
                    {children}
                </Text.Heading>
            </th>
        </tr>
    );
};
